/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, {useEffect, useMemo, useState} from 'react'
//components
//constants
import {useDispatch, useSelector} from 'react-redux'
import {KTSVG} from '../../../../_metronic/helpers'
import {getUserData} from '../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import moment from 'moment'
import {
  FrontendDashboardActivityGraph,
  FrontendDashboardMsgInbound,
} from './FrontEndDashboardSlice/FrontendDashboardSlice'
import ReactApexChart from 'react-apexcharts'
import QuickMessageDrawerInner from '../../../../_metronic/partials/layout/drawer-messenger/Quickmessge'
import {Link, Navigate, useNavigate} from 'react-router-dom'
import {WSSelect} from '../../../../_metronic/helpers/components/WSSelect/WSSelect'
import NodataYet from '../../../Components/NodataYet'
import {CircularProgressbar, buildStyles} from 'react-circular-progressbar'
import {AuthenticateUser} from '../../../Utils/_helpers/RoleAndPermission'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import Spinner from '../../../Components/Spinner'
import {get} from 'lodash'
import {
  useGetDashboardActivityOverviewGraphQuery,
  useGetDashboardEngagementAndRetentionGraphQuery,
  useGetDashboardRecentInboundMessagesQuery,
} from '../../../../services/cellcast'
import {FixedTwoDecimal} from '../../../Utils/_helpers/string'
import {getAllUserDetails, getIsDefaultRegion} from '../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {
  useGetContactCountQuery,
  useLazyGetSubClientRemainingCreditQuery,
} from '../../../../services/cellcast.v2'
import {ContactStatus, GetSubClientShareCreditMode} from '../../../../services/cellcast.v2.types'
import {toast} from 'react-toastify'
import {useLayout} from '../../../../_metronic/layout/core'

/* eslint-disable jsx-a11y/anchor-is-valid */
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!

//constants
//scss
import './DashboardPage.scss'
import {configData} from '../../../../_metronic/helpers'
import {
  FrontendDashboardCalanderData,
  getFEdashboardCalander,
} from './FrontEndDashboardSlice/FrontendDashboardSlice'
import {useRef} from 'react'

const ChartDashboard = ({FELeadGraph, whereWhen, FEDashboardState, FEDashboardGraph}: any) => {
  const navigate = useNavigate()
  const {setQuickMessagePopup} = useLayout()
  const userData: any = useSelector(getAllUserDetails)
  const [isShowCredit, setIsShowCredit] = useState(true)
  const [isSetCreditLimit, setIsShareCreditLimit] = useState(false)
  const [shareCreditRemain, setShareCreditRemain] = useState({
    type: '',
    sms: '-',
    mms: '-',
  })
  const [getRemainCredit] = useLazyGetSubClientRemainingCreditQuery()

  const {data: countSubscriber, isLoading: isCountSubscriberLoading} = useGetContactCountQuery({
    status: ContactStatus.subscribe,
  })
  const {data: countUnsubscribe, isLoading: isCountUnsubscribeLoading} = useGetContactCountQuery({
    status: ContactStatus.unsubscribe,
  })
  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const [quickMessage, setQuickmessage] = useState(false)
  const [campType, setCampType] = useState('sms')
  const [campTypeinbound, setCampTypeInbound] = useState('sms')
  const [contact, setContact] = useState()
  const user = useSelector(getUserData)
  const dispatch = useDispatch()

  const FEEngagementAndRetention: any = useGetDashboardEngagementAndRetentionGraphQuery({
    fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
    toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
  })

  const credits = useSelector((state: any) => state?.userDetails?.userDetails?.data)

  const sendQuickMessage = useMemo(
    () => (
      <QuickMessageDrawerInner
        show={quickMessage}
        handleClose={() => setQuickmessage(false)}
        contacts={[{value: contact, label: contact}]}
      />
    ),
    [quickMessage]
  )
  useEffect(() => {
    dispatch(
      FrontendDashboardMsgInbound({
        camp_type: campTypeinbound,
      })
    )
  }, [campTypeinbound])

  useEffect(() => {
    if (userData && userData.subClientAccountId && userData.subClientAccountId !== '') {
      if (userData._id !== userData.ownerId) {
        setIsShowCredit(false)
        if (userData.subClientLimitConfig) {
          if (
            userData.subClientLimitConfig.smsLimitPerDay > 0 ||
            userData.subClientLimitConfig.mmsLimitPerDay > 0 ||
            userData.subClientLimitConfig.smsLimitPerMonth > 0 ||
            userData.subClientLimitConfig.mmsLimitPerMonth > 0
          ) {
            setIsShareCreditLimit(true)
          }
        }
      }
    }
  }, [userData])

  useEffect(() => {
    if (isSetCreditLimit === true) {
      getRemainCredit(null)
        .then((res) => {
          if ('data' in res) {
            if (res.data && res.data.data) {
              setShareCreditRemain({
                type: res.data.data.mode === GetSubClientShareCreditMode.Day ? `Day` : 'Month',
                sms: res.data.data.credit.sms.toString(),
                mms: res.data.data.credit.mms.toString(),
              })
            }
          } else if ('error' in res) {
            const errObj = res.error as any
            if (errObj.data.message) {
              toast.error(errObj.data.message)
            } else {
              toast.error(res.error)
            }
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
    }
  }, [isSetCreditLimit])

  let typeOption: any = [
    {value: 'sms', label: 'SMS'},
    // TODO: enabled again after MMS been fixed
    {value: 'mms', label: 'MMS'},
  ]

  return (
    <>
      {AuthenticateUser('send-quick-sms') && quickMessage && sendQuickMessage}
      <div className='d-flex flex-row card-number-div-wrapper'></div>

      <div className='col-md-12 mt-6'>
        {/* SMS/WMS and Contacts Section */}
        <div className='row mb-3'>
          <div className='col-md-4'>
            <div className='card py-2' style={{height: '300px'}}>
              <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-4 mb-1'>Send Messages</span>
                  <div>
                    <span className='text-muted fw-light fs-8'>
                      Create and send sms or mms messages in seconds.
                    </span>
                    <span className='text-muted fw-light fs-8'>
                      You can upload contacts, create messages and even buy credits in one process.
                    </span>
                    <span className='text-muted fw-light fs-8'>
                      Create and send sms or mms messages in seconds.select from one of the options
                      below
                    </span>
                  </div>
                </h3>
              </div>
              <div className='card-body d-flex flex-column justify-content-between'>
                <div></div>
                <div className='row text-center'>
                  <div className='col-6'>
                    <button
                      className='btn border-primary btn-outline btn-color-primary btn-active-light-primary px-4'
                      onClick={() => {
                        setQuickMessagePopup(true)
                      }}
                    >
                      <i className='bi fs-3 bi-send'></i>
                      Quick Message
                    </button>
                  </div>
                  <div className='col-6'>
                    <Link
                      to='/new-message'
                      className='btn border-primary btn-outline btn-color-primary btn-active-light-primary'
                    >
                      <KTSVG
                        path='/media/icons/duotune/navigationicon/bulkmsg.svg'
                        className='svg-icon-1x'
                      />
                      Bulk Message
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-4'>
            <div className='card py-2' style={{height: '300px'}}>
              <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-4 mb-1'>Contacts</span>
                  <span className='text-muted fw-light fs-8'>Contacts status</span>
                </h3>
              </div>
              <div className='card-body d-flex flex-column justify-content-between'>
                <div className='row text-center mt-6'>
                  <div className='col-6'>
                    <h2>{countSubscriber?.data ?? 0}</h2>
                    <h5 className='text-muted fw-light fs-8'>Subscribed</h5>
                  </div>
                  <div className='col-6'>
                    <h2>{countUnsubscribe?.data ?? 0}</h2>
                    <h5 className='text-muted fw-light fs-8'>Unsubscribed</h5>
                  </div>
                </div>
                <div className='row text-center px-12'>
                  <Link
                    to='/contacts/subscriber'
                    className='btn border-primary btn-outline btn-color-primary btn-active-light-primary'
                  >
                    <KTSVG
                      path='/media/icons/duotune/communication/com005.svg'
                      className='svg-icon-1x'
                    />
                    Add Contact
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className='col-md-4'>
            <div className='card py-2' style={{height: '300px'}}>
              <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-4 mb-1'>Credit</span>
                  <span className='text-muted fw-light fs-8'>Current Credit</span>
                </h3>
              </div>
              <div className='card-body d-flex flex-column justify-content-between'>
                <div className='row'>
                  <div className='col-6'>
                    <a
                      className={'badge green_text_badge badge-square me-2 p-4 w-50px h-40px '}
                      style={{
                        fontSize: '14px',
                      }}
                    >
                      SMS
                    </a>
                    <h2 className='mt-4' style={{marginBottom: '0px'}}>
                      {isShowCredit
                        ? `${FixedTwoDecimal(credits?.credits?.sms || 0)}`
                        : `${shareCreditRemain.sms}`}
                    </h2>
                    <span className='text-muted fw-light fs-8'>SMS Credits</span>
                  </div>
                  <div className='col-6'>
                    <a
                      className={'badge blue_text_badge badge-square me-2 p-4 w-50px h-40px'}
                      style={{
                        fontSize: '14px',
                      }}
                    >
                      MMS
                    </a>
                    <h2 className='mt-4' style={{marginBottom: '0px'}}>
                      {isShowCredit
                        ? `${FixedTwoDecimal(credits?.credits?.mms || 0)}`
                        : `${shareCreditRemain.mms}`}
                    </h2>
                    <span className='text-muted fw-light fs-8'>MMS Credits</span>
                  </div>
                </div>

                <div className='row text-center px-12'>
                  <Link
                    to='/topup'
                    className='btn border-primary btn-outline btn-color-primary btn-active-light-primary'
                  >
                    <KTSVG path='/media/icons/duotune/finance/fin008.svg' className='svg-icon-1x' />
                    Buy Credit
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Activity Chart and Snapshot Section */}
        <div className='row mb-6 mt-6'>
          <div className='col-md-9'>
            <div className='px-3'>
              <ConfigDashboard />
            </div>
          </div>
          <div className='col-md-3'>
            <div className='card py-2'>
              <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-4 mb-1'>Snapshot</span>
                  <span className='text-muted fw-light fs-8'>Last Campaign Snapshot</span>
                </h3>
              </div>
              <div className='card-body'>
                <div
                  className='d-grid mt-6'
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gridTemplateRows: 'repeat(2, 1fr)',
                    gap: '20px',
                    height: '100%',
                  }}
                >
                  <div className='d-flex flex-column align-items-center justify-content-center'>
                    <h1>-</h1>
                    <span className='text-muted fw-light fs-8'>Outbound</span>
                  </div>
                  <div className='d-flex flex-column align-items-center justify-content-center'>
                    <h1>-</h1>
                    <span className='text-muted fw-light fs-8'>Inbound</span>
                  </div>
                  <div className='d-flex flex-column align-items-center justify-content-center'>
                    <h1>{FEEngagementAndRetention?.data?.data?.total.clickThrough}</h1>
                    <span className='text-muted fw-light fs-8'>Clicks</span>
                  </div>
                  <div className='d-flex flex-column align-items-center justify-content-center'>
                    <h1>{FEDashboardState?.data?.data?.CTRCount}</h1>
                    <span className='text-muted fw-light fs-8'>CTR</span>
                  </div>
                </div>
              </div>
            </div>

            <div className='card mt-6 py-2'>
              <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-4 mb-1'>Configurations</span>
                  <span className='text-muted fw-light fs-8'>Integrations, API and more</span>
                </h3>
              </div>
              <div className='card-body'>
              {isDefaultRegion ? (
                <div>
                {configData?.map((data, idx) => (
                  <div className='row mb-5' key={idx}>
                    <div className='col-10'>
                      <h3 className='card-title d-flex align-items-start flex-column'>
                        <span className='card-label fw-bolder fs-6'>{data.title}</span>
                      </h3>
                      <span className='text-muted fw-light fs-8 w-100px'>{data.description}</span>
                    </div>
                    <div className='col-2 d-flex flex-end p-1'>
                      <OverlayTrigger
                        placement='bottom'
                        overlay={<Tooltip id='button-tooltip'>View Detail</Tooltip>}
                      >
                        <a
                          onClick={() => navigate(data?.path)}
                          className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                        >
                          <KTSVG
                            path='/media/icons/duotune/arrows/arr064.svg'
                            className='svg-icon-2'
                          />
                        </a>
                      </OverlayTrigger>
                    </div>
                  </div>
                ))}
                </div>
                ) : (
                <div>
                  
                  <p>Coming Soon</p>
                  
                </div>
              )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ChartDashboard

const ConfigDashboard = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const calendarRef: any = useRef(null)
  const calanderData = useSelector(getFEdashboardCalander)
  const [eventHoverInfo, setEventHoverInfo] = useState<any>(null)
  const [campType, setCampType] = useState('sms')
  const [mousePosition, setMousePosition] = useState({x: 0, y: 0})
  let options: any = [
    {value: 'sms', label: 'SMS'},
    {value: 'mms', label: 'MMS'},
  ]
  useEffect(() => {
    dispatch(
      FrontendDashboardCalanderData({
        fromDate: moment(calendarRef.current.getApi()?.currentDataManager?.data?.currentDate)
          .startOf('month')
          .format('YYYY-MM-DD'),
        toDate: moment(calendarRef.current.getApi()?.currentDataManager?.data?.currentDate)
          .endOf('month')
          .format('YYYY-MM-DD'),
        camp_type: campType,
      })
    )
  }, [campType])

  const calendarEvents = () => {
    const data = calanderData?.map((key: any) => ({
      title: key?.name,
      date: moment(key?.scheduleAt ? key?.scheduleAt : key?.createdAt)?.format('YYYY-MM-DD'),
      description: moment(key?.scheduleAt ? key?.scheduleAt : key?.createdAt)?.format('LLL'),
      message: key?.message,
      campType: key?.camp_type,
    }))

    return data
  }
  const handleEventMouseEnter = (info: any) => {
    setEventHoverInfo(info.event)
  }

  const handleEventMouseLeave = () => {
    setEventHoverInfo(null)
  }

  return (
    <>
      <div className='d-flex flex-row calender_wrapper'>
        <div className='card'>
          <div className='card-header border-botton-1  pt-4 pb-4'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bolder fs-4 mb-1'>Calendar</span>
            </h3>
            <div className='card-toolbar'>
              {/* <WSSelect
                value={campType}
                onChange={(e: any) => setCampType(e.value)}
                placeholder='All campaigns'
                options={options}
                className='w-150px me-4'
              /> */}
              {/* <span className='btn btn-sm btn-primary py-3 px-5'>New message</span> */}
            </div>
          </div>
          <div className='card-body'>
            <div className='calender-style '>
              <FullCalendar
                ref={calendarRef}
                headerToolbar={{
                  start: 'prevButton', // will normally be on the left. if RTL, will be on the right
                  center: 'title',
                  end: 'nextButton', // will normally be on the right. if RTL, will be on the left
                }}
                customButtons={{
                  nextButton: {
                    text: ``,
                    click: (e: any) => {
                      let calendarApi = calendarRef.current.getApi()
                      dispatch(
                        FrontendDashboardCalanderData({
                          fromDate: moment(calendarApi?.currentDataManager?.data?.currentDate)
                            .add(1, 'month')
                            .startOf('month')
                            .format('YYYY-MM-DD'),
                          toDate: moment(calendarApi?.currentDataManager?.data?.currentDate)
                            .add(1, 'month')
                            .endOf('month')
                            .format('YYYY-MM-DD'),
                          camp_type: campType,
                        })
                      )
                      calendarApi.next()
                    },
                    icon: 'chevron-right',
                  },
                  prevButton: {
                    text: '',
                    click: (e: any) => {
                      let calendarApi = calendarRef.current.getApi()
                      dispatch(
                        FrontendDashboardCalanderData({
                          fromDate: moment(calendarApi?.currentDataManager?.data?.currentDate)
                            .subtract(1, 'month')
                            .startOf('month')
                            .format('YYYY-MM-DD'),
                          toDate: moment(calendarApi?.currentDataManager?.data?.currentDate)
                            .subtract(1, 'month')
                            .endOf('month')
                            .format('YYYY-MM-DD'),
                          camp_type: campType,
                        })
                      )
                      calendarApi.prev()
                    },
                    icon: 'chevron-left',
                  },
                }}
                // eventMouseEnter={handleEventMouseEnter}
                eventClick={handleEventMouseEnter}
                eventMouseLeave={handleEventMouseLeave}
                plugins={[dayGridPlugin]}
                initialView='dayGridMonth'
                events={calendarEvents()}
              />
            </div>
            {eventHoverInfo && (
              <div className='popup' style={{left: mousePosition.x, top: mousePosition.y}}>
                <h3>
                  {eventHoverInfo?.extendedProps?.campType?.toUpperCase()} - {eventHoverInfo.title}
                </h3>
                <p>{eventHoverInfo.extendedProps?.description}</p>
                <pre>{eventHoverInfo.extendedProps?.message}</pre>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
